var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page map-page"},[_c('map-main-menu'),_c('router-view'),_c('my-map'),_c('map-type-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }